import React, { useRef } from 'react';
import ViewItems from '../../../components/ViewItems';
import { useSelector } from 'react-redux';
import { getContentKeyAccToLang, showToast } from '../../../utils/utils';
import dynamicfunction from '../../../utils/dynamicfunction';
import Button from '../../../components/Button';
import ViewReverse from '../../../components/ViewReverse';
import { ReactSVG } from 'react-svg';
import Text from '../../../components/Text';
import { fontSizes } from '../../../constants/constants';
import icons from '../../../constants/icons';

const MAX_FILE_SIZE_MB = 10;

const DocumentView = ({ image, setImage }) => {
  const { TextWeight, isArabic } = dynamicfunction();
  const { helpContent } = useSelector((state) => state.content);

  const inputRef = useRef(null);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      helpContent?.web_help_contact?.data?.attributes,
      key,
      isArabic
    );
  };

  const handleClick = () => {
    if (inputRef.current) inputRef.current?.click();
  };

  const ALLOWED_FILE_TYPES = [
    'application/pdf',
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/gif',
  ];

  const ALLOWED_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'gif'];
  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    const fileSizeValid = file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;
    const fileTypeValid =
      ALLOWED_FILE_TYPES.includes(file.type) ||
      ALLOWED_EXTENSIONS.includes(file.name.split('.').pop().toLowerCase());

    if (!fileTypeValid) {
      showToast({
        icon: 'error',
        title:
          getContentKey('invalid_file_type') ||
          'Only PDF, JPG, JPEG, PNG, and GIF file formats are allowed.',
      });
      e.target.value = '';
      return;
    }

    if (!fileSizeValid) {
      showToast({
        icon: 'error',
        title: getContentKey('file_size_error'),
      });
      e.target.value = '';
      setImage(null);
      return;
    }

    setImage(file);
  };

  return (
    <ViewItems
      className={
        'border-[1px] border-primary border-dashed rounded-lg p-4 w-full'
      }
    >
      <ViewReverse className={'gap-7 items-center mb-4'}>
        <ReactSVG src={icons.link} />

        <ViewItems className={'gap-2'}>
          <Text
            text={getContentKey('upload_files')}
            color='text-primary'
            size={fontSizes.h14}
          />
          <Text
            text={image?.name ?? getContentKey('upload_instructions')}
            color='text-primary'
            weight={TextWeight.light}
            isTruncate={false}
          />
        </ViewItems>
      </ViewReverse>

      <input
        ref={inputRef}
        type='file'
        className='hidden'
        accept='.pdf,.jpg,.jpeg,.png,.gif'
        onChange={handleFileChange}
      />

      <Button
        text={getContentKey('upload')}
        bgColor={'bg-transparent'}
        color='text-primary'
        className={'border border-primary w-full'}
        onClick={handleClick}
      />
    </ViewItems>
  );
};

export default DocumentView;
